/*eslint-disable no-throw-literal */
/*eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import { Row, Col, Card } from 'react-bootstrap';
import jsPDF from 'jspdf';
import APIEndpoints from '../../../api/APIEndpoints';
import { axiosInstance } from 'src/api/axios';
import { ToastContainer, toast } from 'react-toastify';
//import pdf2base64 from 'pdf-to-base64';
import { InfoCircleOutlined } from '@ant-design/icons';
import { IDCardEmailBody } from 'src/Member/configuration/EmailData';
import AutoSuggestionSelectComponent from 'src/Member/components/common/auto-suggestion-select/Select';
import MyIDCardSkeleton from './MyIDCardSkeleton';
import './myidcards.scss';
import { ClaimDetailsSVG } from 'src/Member/img/GlobalSVG';
import { IdcardCoverageFilter } from './card-filter/idcardCoverageFilter';
import { getFamilyList } from '../../../../Member/utils/Coverage';
import CustomClientError from '../../../errorhandling/CustomClientError';
import GenericButton from '../../../../Components/GenericButton/GenericButton';
import { HttpSuccessCodes } from 'src/Member/errorhandling/HttpErrorCodes';
import Feature from '../../../../services/feature';
import { useTranslation } from 'react-i18next';
import ToastMessage from '../../common/ToastMessage';
import { useSelector } from 'react-redux';
import HttpHeader from '../../../shared/httpheader';
import Zoom from 'react-medium-image-zoom';
import MasterPermissions from '../../../api/MasterPermissions';
import Skeleton from '../../common/skeleton';

const MyIDCards = (props) => {
  const [sendingEmailLoader, setSendingEmailLoader] = useState(false);
  const [IDCard, setIDCard] = useState(null);
  const [dataFetching, setDataFetching] = useState(false);
  const [IDCardPdf, setIDCardPdf] = useState(null);
  const { t } = useTranslation();
  const CVRGTYPES = [];
  const cName = HttpHeader.getCNAME();

  const [showNewIdCardPanel, setShowNewIdCardPanel] = useState(false);
  const [selectedPerson, setSelectedPerson] = useState(null);

  const {
    MemberStatePreserve: { coverageSummary },
  } = useSelector(({ memberSummary }) => memberSummary);

  const { Email_Configration } = useSelector(
    (state) => state.app?.appConfigs || {},
  );

  const coverageTypes = [];
  const optionsForIDCard = [];
  props.coverageProducts.map((item) => {
    if (
      item.Product != 'ShortTermDisability' &&
      item.Product != 'LongTermDisability' &&
      item.Product != 'VL as Sec Coverage' &&
      item.Product != 'Flex'
    ) {
      coverageTypes.push({ label: item.Product, value: item.Product });
      if (item.Product === 'Medical') {
        optionsForIDCard.push({ label: 'Medical Front', value: 'm' });
        optionsForIDCard.push({ label: 'Medical Back', value: 'b' });
      } else if (item.Product === 'Dental') {
        optionsForIDCard.push({ label: 'Dental', value: 'd' });
      } else if (item.Product === 'Vision') {
        optionsForIDCard.push({ label: 'Vision', value: 'v' });
      }
    }
  });

  const CoverageTypeProps = {
    options: coverageTypes,
    selectedCoverage: selectCoverageType,
  };

  const [selectCoverageType, setSelectCoverageType] = useState(
    coverageTypes[0],
  );

  const [productTypesIDCard, setProductTypesIDCard] =
    useState(optionsForIDCard);
  const [activeCoverageTypeIDCard, setActiveCoverageTypeIDCard] = useState(
    optionsForIDCard[0],
  );

  useEffect(() => {
    if (optionsForIDCard.length > 0) {
      getIDCardInformation(null, null, optionsForIDCard[0].value);
    } else {
      setIDCard('error');
      setIDCardPdf('error');
    }
  }, [props.userOID]);

  const CoverageTypeChangeHandler = (selectedValue) => {
    //setIDCardPdf( '' );
    if (selectedValue === selectCoverageType) {
      return;
    }
    setSelectCoverageType(selectedValue);
  };

  const handleRequestIdCard = () => {
    setShowNewIdCardPanel(true);
  };

  const getIDCardInformation = async (
    typeOfUser = null,
    userOID = null,
    cardType = null,
  ) => {
    if (
      cName.includes('keenan') ||
      cName.includes('tpabenefits') ||
      cName.includes('mybenefits') ||
      cName.includes('roundstone') ||
      cName.includes('a1m-qa') ||
      cName.includes('a1m-demo')
    ) {
      let getIdCardResponse;
      let getIdCardDataResp;
      try {
        setDataFetching(true);
        setIDCardPdf('');
        setIDCard('');

        let idCardUrl = null;
        if (cName.includes('keenan') || cName.includes('tpabenefits')) {
          const planTypeName =
            cardType != null ? cardType : activeCoverageTypeIDCard.value;
          idCardUrl =
            APIEndpoints.GetMemberIdCard() +
            props.memberType +
            '/plantype/' +
            planTypeName +
            '/oid/' +
            props.userOID;
        } else {
          idCardUrl =
            APIEndpoints.GetMemberIdCard() +
            props.memberType +
            '/oid/' +
            props.userOID;
        }

        getIdCardResponse = await axiosInstance.get(idCardUrl, {
          responseType: 'arraybuffer',
        });
        getIdCardDataResp = getIdCardResponse.data;
        if (getIdCardDataResp?.byteLength < 20000 || getIdCardDataResp === '') {
          setIDCard('error');
          return;
        } else if (
          getIdCardResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
        ) {
          setIDCard(arrayBufferToBase64(getIdCardDataResp));
          await getIDCardPdf();
        }
        //setDataFetching( false );
      } catch (error) {
        setIDCard('error');
        //setDataFetching( false );
      } finally {
        if (
          cName.includes('mybenefits') ||
          cName.includes('roundstone') ||
          cName.includes('a1m-qa') ||
          cName.includes('a1m-demo') ||
          cName.includes('keenan') ||
          cName.includes('tpabenefits')
        ) {
          await getIDCardPdf();
        } else {
          setDataFetching(false);
        }
      }
    } else {
      setIDCard('error');
    }
  };

  //Generating File conent for pdf generation
  const arrayBufferToBase64 = (buffer) => {
    let binary = '';
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  };

  const sendIDCardEmail = async () => {
    //setIDCardPdf( '' );
    setSendingEmailLoader(true);
    if (
      window.location.hostname.includes('keenan') ||
      window.location.hostname.includes('tpabenefits')
    ) {
      IDCardEmailBody['FromName'] = 'Keenan';
      IDCardEmailBody['Subject'] = IDCardEmailBody['Subject'].replace(
        'A1MHealth',
        'Keenan',
      );
      IDCardEmailBody[
        'Message'
      ] = `As requested, enclosed is your member ID card. You can use this new ID card for your next visit to the provider.If you have any questions or concerns, please call the Keenan member service phone number displayed on the top of your ID card.


    Sincerely,
    Keenan.
      `;
    }
    if (cName.includes('mybenefits') || cName.includes('roundstone')) {
      IDCardEmailBody['FromName'] = 'Bywater';
      IDCardEmailBody['Subject'] = IDCardEmailBody['Subject'].replace(
        'A1MHealth',
        'Bywater',
      );
      IDCardEmailBody[
        'Message'
      ] = `We’ve enclosed a copy of your requested Bywater ID card. If you have any questions or concerns, please contact our customer service center at 1-800-337-0792 for further assistance


    At your service,
    Bywater
      `;
    }
    IDCardEmailBody['ToAddress'] = props.selectedUserEmail;
    IDCardEmailBody['ToName'] = props.selectedUserFirstName;

    IDCardEmailBody['Message'] = `Dear ${props.selectedUserFirstName},
  
      ${IDCardEmailBody['Message']}
    `;
    IDCardEmailBody['FromAddress'] = Email_Configration.Sender_Email;
    IDCardEmailBody[
      'FileName'
    ] = `${props.selectedUserFirstName}-${props.selectedUserLastName}-IDCard.pdf`;
    IDCardEmailBody[
      'FileDescription'
    ] = `${props.selectedUserFirstName}-${props.selectedUserLastName}-IDCard.pdf`;
    try {
      if (!props.selectedUserEmail || !props.selectedUserFirstName)
        throw {
          code: 1,
          message:
            'ID Card could not be sent as Email address was not available. Contact your Administrator for further details.',
        };
      if (IDCardPdf != 'error') {
        IDCardEmailBody['FileContent'] = arrayBufferToBase64(IDCardPdf);
        try {
          const EmailResponse = await axiosInstance.post(
            APIEndpoints.getSendEmailResource(),
            IDCardEmailBody,
          );
          if (EmailResponse) {
            toast.success(
              <ToastMessage
                type="success"
                title="Request was completed successfully."
                subTitle={`ID Card has been sent to your registered email - ${IDCardEmailBody.ToAddress}.`}
              />,
            );
          } else {
            toast.error(
              <ToastMessage
                type="error"
                title="Request was not completed."
                subTitle={`ID Card has not sent to your registered email - ${IDCardEmailBody.ToAddress}.`}
              />,
            );
          }
        } catch (error) {
          console.error('Email error', error);

          toast.error(
            <ToastMessage
              type="error"
              title="Request was not completed."
              subTitle={`IDCard has not sent to your registered email - ${IDCardEmailBody.ToAddress}.`}
            />,
          );
        }
      }
    } catch (error) {
      console.error('Id card pdf conversion error', error);

      let msg = `IDCard has not sent to your registered email - ${IDCardEmailBody.ToAddress}.`;

      if (1 === error.code) msg = error.message;

      toast.error(
        <ToastMessage
          type="error"
          title="Request was not completed."
          subTitle={msg}
        />,
      );
    } finally {
      setSendingEmailLoader(false);
    }
  };

  const DownloadFile = async (typeOfUser = null, userOID = null) => {
    if (IDCardPdf != 'error') {
      const fileURL = window.URL.createObjectURL(new Blob([IDCardPdf]));
      const downloadIDCardLink = document.createElement('a');
      downloadIDCardLink.href = fileURL;
      downloadIDCardLink.download = `${props.selectedUserFirstName}-${props.selectedUserLastName}-IDCard.pdf`;
      document.body.appendChild(downloadIDCardLink);
      downloadIDCardLink.click();
      document.body.removeChild(downloadIDCardLink);
    }
  };

  const getRequestedIdCard = async (typeOfUser = null, userOID = null) => {
    try {
      const userDetails = {
        MemberOid: props.userOID,
        MemberType: props.memberType,
        Product: selectCoverageType.value,
      };

      const response = await axiosInstance.put(
        APIEndpoints.getRequestedIDCard(),
        userDetails,
      );

      if (
        [
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200,
          HttpSuccessCodes.HTTP_SUCCESS_CODE_201,
        ].includes(response.status)
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={t('member.download_idcard.new_idcard_successful')}
          />,
        );
      }
    } catch (e) {
      console.log('API ERROR', e);
      if (e.response.status === 404) {
        if (
          e?.response?.data?.message ===
            'You have already requested for a new ID Card! Check the request status for more information.' &&
          (cName.includes('keenan') || cName.includes('tpabenefits'))
        ) {
          toast.error(
            <ToastMessage
              type="error"
              subTitle="You have already requested a new ID Card. Please allow up to 2 weeks for it to arrive."
            />,
          );
        } else {
          toast.error(
            <ToastMessage type="error" subTitle={e?.response?.data?.message} />,
          );
        }
      }
      if (e.response.status === 500) {
        toast.error(
          <ToastMessage
            type="error"
            subTitle={t('member.download_idcard.id_card_500_status')}
          />,
        );
      }
    }
  };
  const getIDCardPdf = async (typeOfUser = null, userOID = null) => {
    let getIdCardPdfResponse;
    let getIdCardPdfDataResp;

    try {
      setIDCardPdf('');
      if (
        cName.includes('mybenefits') ||
        cName.includes('roundstone') ||
        cName.includes('a1m-qa')
      ) {
        const echoIdCardUrl = cName.includes('a1m-qa')
          ? APIEndpoints.GetMemberIdCardPdfEcho() +
            'dependent/oid/e7f2b2f7-fd1d-44d4-9651-f2e19af6b368'
          : APIEndpoints.GetMemberIdCardPdfEcho() +
            props.memberType +
            '/oid/' +
            props.userOID;
        getIdCardPdfResponse = await axiosInstance.get(echoIdCardUrl, {
          responseType: 'arraybuffer',
        });
      } else {
        getIdCardPdfResponse = await axiosInstance.get(
          APIEndpoints.GetMemberIdCardPdf() +
            props.memberType +
            '/oid/' +
            props.userOID,
          { responseType: 'arraybuffer' },
        );
      }
      getIdCardPdfDataResp = getIdCardPdfResponse.data;
      if (
        getIdCardPdfDataResp?.byteLength < 15000 ||
        getIdCardPdfDataResp === ''
      ) {
        setIDCardPdf('error');
        return;
      }
      if (
        getIdCardPdfResponse.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        setIDCardPdf(getIdCardPdfDataResp);
      }
    } catch (error) {
      setIDCardPdf('error');
    } finally {
      setDataFetching(false);
    }
  };

  const CoverageTypeChangeHandlerIDCard = (selectedValue) => {
    if (selectedValue.value === activeCoverageTypeIDCard.value) {
      return;
    }
    setActiveCoverageTypeIDCard(selectedValue);
    getIDCardInformation(null, null, selectedValue.value);
  };

  return (
    <>
      {optionsForIDCard.length > 0 && (
        <IdcardCoverageFilter
          CoverageTypeProps={{
            options: productTypesIDCard,
            selectedCoverage: activeCoverageTypeIDCard,
          }}
          CoverageTypeChangeHandler={CoverageTypeChangeHandlerIDCard}
        />
      )}

      {dataFetching && IDCard !== 'error' && IDCardPdf !== 'error' ? (
        <MyIDCardSkeleton />
      ) : (
        <>
          <div className="card-container container-offset">
            {props.isFamilySelected ? (
              <CustomClientError ErrorHeading="To view ID Card, select a Member or Dependent from Show Details drop-drown. " />
            ) : (
              <div className="card-details">
                <Row>
                  <Col>
                    {IDCard !== 'error' && (
                      <div className="image-display-divison">
                        {/*<Zoom zoomMargin={40}> */}
                        <img
                          className="id-card"
                          width={'100%'}
                          src={'data:image/png;base64, ' + IDCard}
                          alt="Id Card"
                        />
                        {/*</Zoom> */}
                      </div>
                    )}
                    {IDCard === 'error' && IDCardPdf === 'error' && (
                      <div className="d-flex flex-wrap download_idcard_imginfo_no">
                        <p className="mt-2">
                          {t('member.download_idcard.no_id_card')}
                        </p>
                      </div>
                    )}

                    {/*<div className="download_idcard_imginfo" aria-live="polite">
                    A preview image is unavailable. However, you can download PDF
                    version of ID Card. <br />
                    Remember: ID Cards are for identification purposes only; they
                    do not guarantee eligibility or payment of your claim.
                    </div> */}
                  </Col>
                </Row>
                <Row className="mt-2 mb-3">
                  {IDCardPdf !== 'error' && (
                    <Col>
                      {IDCardPdf?.byteLength > 15000 || IDCardPdf != '' ? (
                        <>
                          <GenericButton
                            variant="primary"
                            className="download"
                            onClick={DownloadFile}
                          >
                            <ClaimDetailsSVG.ClaimDetailDownloadSVG />
                            Download PDF
                          </GenericButton>
                          {props.selectedUserEmail != undefined &&
                            props.selectedUserEmail != '' && (
                              <GenericButton
                                variant="link"
                                className="email"
                                onClick={sendIDCardEmail}
                              >
                                <ClaimDetailsSVG.SendSVG />
                                Send Email
                              </GenericButton>
                            )}
                        </>
                      ) : (
                        <Row>
                          <Col sm={4}>
                            <Row>
                              <Col sm={6}>
                                <Card className="p-3">
                                  <Skeleton
                                    count={1}
                                    height={20}
                                    className="Id-Card-Image"
                                  />
                                </Card>
                              </Col>
                              <Col sm={6}>
                                <Card className="p-3">
                                  <Skeleton
                                    count={1}
                                    height={20}
                                    className="Id-Card-Image"
                                  />
                                </Card>
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      )}
                      {IDCardPdf === 'error' && (
                        <p>
                          failed to download Id card please try after sometime
                        </p>
                      )}
                    </Col>
                  )}
                </Row>
                {(cName.includes('mybenefits') ||
                  cName.includes('roundstone')) && (
                  <>
                    <Row>
                      <Col>
                        <div>
                          <p>
                            Please be mindful of the following information.....
                          </p>
                          <ol>
                            <li>
                              <p>
                                Your ID card may take longer than expected to
                                load
                              </p>
                            </li>
                            <li>
                              <p>
                                If you are a dependent downloading an ID card,
                                the name of the primary policy holder will
                                appear on the downloaded card
                              </p>
                            </li>
                          </ol>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                <Row className="mt-4">
                  <Col className="newidcard">
                    <h4>{t('member.download_idcard.need_replacement')} </h4>
                    {cName.includes('mybenefits') ||
                    cName.includes('roundstone') ||
                    cName.includes('a1m-qa') ? (
                      <></>
                    ) : (
                      <div className="replacementCard_info">
                        {t('member.download_idcard.replacement_card_info')}
                        {/*<a href="/member/dashboard-work-in-progress"> */}{' '}
                        {t('member.download_idcard.contact_us')}
                        {/*</a> */}
                      </div>
                    )}

                    <GenericButton
                      onClick={handleRequestIdCard}
                      variant="secondary"
                      ariaLabel="Request for new id card"
                    >
                      {t('member.download_idcard.request_newcard')}
                    </GenericButton>
                  </Col>
                </Row>
                {showNewIdCardPanel && (
                  <>
                    <h4>{t('member.download_idcard.request_newcard')} </h4>
                    <Row className="newidcard_dropDown">
                      <Col md={4}>
                        <label htmlFor="IdCardFor" className="m-0">
                          Card Type
                        </label>
                        <AutoSuggestionSelectComponent
                          placeholder="All"
                          options={CoverageTypeProps.options}
                          components={{ IndicatorSeparator: () => null }}
                          value={selectCoverageType}
                          onChange={CoverageTypeChangeHandler}
                          id="IdCardFor"
                          labelText="ID Card for"
                        />
                      </Col>
                    </Row>
                    <div className="replacementCard_info">
                      Card will be sent to your registered mailing address.
                    </div>
                    <GenericButton
                      onClick={getRequestedIdCard}
                      className="mb-3"
                      aria-label="Request for new id card"
                    >
                      {t('label_submit')}
                    </GenericButton>
                    {/*<StepperBar /> */}
                  </>
                )}
                {(cName.includes('mybenefits') ||
                  cName.includes('roundstone')) && (
                  <Row>
                    <Col>
                      <div className="download_info">
                        <p>
                          Please allow up to 10 business days for your ID card
                          request to be processed and mailed
                        </p>
                        <p>
                          For any technical difficulties, please contact the
                          Bywater service center{' '}
                          <a href="tel:+1-800-337-0792">1-800-337-0792</a>.
                        </p>
                      </div>
                    </Col>
                  </Row>
                )}
              </div>
            )}
          </div>
        </>
      )}
    </>
  );
};
export default MyIDCards;
